import { State } from '@meraki-internal/state';

/**
 * Which care map a page is showing right now. The active care map outlives the page that opened it
 * (it is restored at startup and kept while the person is elsewhere), so anything that must know
 * what is actually on screen, rather than what was last opened, reads this. Every page showing a
 * care map wraps it in ActiveCareMapProviderV2, which is what enters and leaves here.
 */
export class CareMapOnScreen extends State<Record<string, never>> {
    // Drawers over a care map page mount a second provider for the same care map, so each id is
    // counted rather than flagged.
    private providersByCareMapId = new Map<string, number>();

    constructor() {
        super({});
    }

    enter = (careMapId: string) => {
        const count = this.providersByCareMapId.get(careMapId) ?? 0;
        // Re-set so the last entered is last in the map.
        this.providersByCareMapId.delete(careMapId);
        this.providersByCareMapId.set(careMapId, count + 1);
        this.setState({});
    };

    leave = (careMapId: string) => {
        const remaining = (this.providersByCareMapId.get(careMapId) ?? 1) - 1;
        if (remaining > 0) {
            this.providersByCareMapId.set(careMapId, remaining);
        } else {
            this.providersByCareMapId.delete(careMapId);
        }
        this.setState({});
    };

    /** The last entered that is still on screen, should two pages ever overlap. */
    getCareMapId = (): string | undefined => {
        let newest: string | undefined;
        for (const careMapId of this.providersByCareMapId.keys()) {
            newest = careMapId;
        }
        return newest;
    };
}
